var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.12354H4.5C3.25736 4.12354 2.25 5.13089 2.25 6.37354V19.8735C2.25 21.1162 3.25736 22.1235 4.5 22.1235H19.5C20.7426 22.1235 21.75 21.1162 21.75 19.8735V6.37354C21.75 5.13089 20.7426 4.12354 19.5 4.12354Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 12.3735C14.4963 12.3735 15 11.8699 15 11.2485C15 10.6272 14.4963 10.1235 13.875 10.1235C13.2537 10.1235 12.75 10.6272 12.75 11.2485C12.75 11.8699 13.2537 12.3735 13.875 12.3735Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 12.3735C18.2463 12.3735 18.75 11.8699 18.75 11.2485C18.75 10.6272 18.2463 10.1235 17.625 10.1235C17.0037 10.1235 16.5 10.6272 16.5 11.2485C16.5 11.8699 17.0037 12.3735 17.625 12.3735Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 16.1235C14.4963 16.1235 15 15.6199 15 14.9985C15 14.3772 14.4963 13.8735 13.875 13.8735C13.2537 13.8735 12.75 14.3772 12.75 14.9985C12.75 15.6199 13.2537 16.1235 13.875 16.1235Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 16.1235C18.2463 16.1235 18.75 15.6199 18.75 14.9985C18.75 14.3772 18.2463 13.8735 17.625 13.8735C17.0037 13.8735 16.5 14.3772 16.5 14.9985C16.5 15.6199 17.0037 16.1235 17.625 16.1235Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 16.1235C6.99632 16.1235 7.5 15.6199 7.5 14.9985C7.5 14.3772 6.99632 13.8735 6.375 13.8735C5.75368 13.8735 5.25 14.3772 5.25 14.9985C5.25 15.6199 5.75368 16.1235 6.375 16.1235Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 16.1235C10.7463 16.1235 11.25 15.6199 11.25 14.9985C11.25 14.3772 10.7463 13.8735 10.125 13.8735C9.50368 13.8735 9 14.3772 9 14.9985C9 15.6199 9.50368 16.1235 10.125 16.1235Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 19.8735C6.99632 19.8735 7.5 19.3699 7.5 18.7485C7.5 18.1272 6.99632 17.6235 6.375 17.6235C5.75368 17.6235 5.25 18.1272 5.25 18.7485C5.25 19.3699 5.75368 19.8735 6.375 19.8735Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 19.8735C10.7463 19.8735 11.25 19.3699 11.25 18.7485C11.25 18.1272 10.7463 17.6235 10.125 17.6235C9.50368 17.6235 9 18.1272 9 18.7485C9 19.3699 9.50368 19.8735 10.125 19.8735Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 19.8735C14.4963 19.8735 15 19.3699 15 18.7485C15 18.1272 14.4963 17.6235 13.875 17.6235C13.2537 17.6235 12.75 18.1272 12.75 18.7485C12.75 19.3699 13.2537 19.8735 13.875 19.8735Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.62354V4.12354M18 2.62354V4.12354",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 7.87354H2.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutline);
export default __webpack_public_path__ + "static/media/calendar-outline.0db56a1881f1bc74dc31130265c85a19.svg";
export { ForwardRef as ReactComponent };